<div class="sidebar-bg"></div>
<div class="sidebar" role="navigation" aria-label="Desktop side nav">
  <div class="sidebar-content" *ngIf="userData">
    <div class="logo">
      <img src="/assets/img/logo-prepwell-dark.svg" alt="logo" class="logo" />
    </div>
    <form class="search-form goal-form mt-3 mb-3" name="searchForm">
      <div class="form-group">
        <label for="q" class="sr-only">Search</label>

        <input
          type="text"
          class="form-control"
          placeholder="Search"
          name="q"
          id="q"
          #q="ngModel"
          ngModel
          (keyup.enter)="onSearch(q)"
        />
        <button
        
          (click)="onSearch(q)"
          class="btn-transparent btn btn-primary-outline"
        >
          <span class="icon-wrap"
            ><fa-icon [icon]="['fas', 'search']"></fa-icon
            ><span class="sr-only">Search</span></span
          >
        </button>
      </div>
    </form>

    <!--div class="ms-auto btn-group user-menu-group" dropdown>
      <a id="user-dropdown-btn-sv" dropdownToggle>
        <img
          src="{{ avatarBase + userData.avatar }}"
          alt="user avatar"
          class="avatar rounded"
          width="40"
          height="40"
          *ngIf="userData.avatar"
        />
        <span class="avatar-icon icon-wrap" *ngIf="!userData.avatar">
          <fa-icon [icon]="['fal', 'user']"></fa-icon>
        </span>
        <span class="user-name"
          >{{ userData.first_name + " " + userData.last_name }}
        </span>
        <span class="icon-wrap float-end"
          ><fa-icon [icon]="['far', 'chevron-down']"></fa-icon
        ></span>
        <span class="sr-only">User Menu</span>
      </a>
      <ul
        id="dropdown-user"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="user-dropdown-btn-sb"
      >
        <li role="menuitem">
          <a class="dropdown-item" [routerLink]="['/update-details']"
            >Update Details</a
          >
        </li>
        <li role="menuitem">
          <a class="dropdown-item" [routerLink]="['/upload-avatar']"
            >Upload Avatar</a
          >
        </li>
        <li role="menuitem">
          <a class="dropdown-item" [routerLink]="['/change-password']"
            >Change Password</a
          >
        </li>
        <li role="menuitem">
          <a class="dropdown-item" [routerLink]="['']" (click)="onLogout()"
            >Logout</a
          >
        </li>
      </ul>
    </div-->

    <nav class="sidebar-nav sidebar-nav-user">
    <ul class="nav flex-column">
      <li class="nav-item">
        <a
        (click)="toggleUserMenu=!toggleUserMenu"
          class="nav-link pointer"
          [ngClass]="{active:toggleUserMenu}"
        >
        <img
        src="{{ avatarBase + userData.avatar }}"
        alt="user avatar"
        class="avatar rounded"
        width="40"
        height="40"
        *ngIf="userData.avatar"
      />
      <span class="avatar-icon icon-wrap" *ngIf="!userData.avatar">
        <fa-icon [icon]="['fas', 'user']"></fa-icon>
      </span>
          <span class="nav-link-title">{{ userData.first_name + " " + userData.last_name }}</span>
        </a>
        <ul class="nav flex-column fade-in animate-250">
          <li class="nav-item">
            <a 
              class="nav-link"
              [routerLink]="['/update-details']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="icon-wrap duo-primary-dark">
                <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
              </span>
              Update Details
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [routerLink]="['/upload-avatar']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="icon-wrap duo-primary-dark">
                <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
              </span>
              Upload Avatar
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              [routerLink]="['/change-password']"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <span class="icon-wrap duo-primary-dark">
                <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
              </span>
              Change Password
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link pointer"
              tabindex="0"
              (click)="onLogout()"
            >
              <span class="icon-wrap duo-primary-dark">
                <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
              </span>
              Logout
            </a>
          </li>
        </ul>
      </li>
    </ul>
    </nav>
    
    <nav class="sidebar-nav">
      <ul class="nav flex-column">
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/dashboard']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'house']"></fa-icon>
            </span>
            <span class="nav-link-title">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/programme']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'calendar-alt']"></fa-icon>
            </span>
            <span class="nav-link-title">Programme</span>
          </a>
          <ul class="nav flex-column fade-in animate-250">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/programme', 'progress']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Overall Progress
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/programme', 'task-list']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Weekly Objectives
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/programme', 'weekly-reports']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Weekly Reports
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/programme', 'achievements']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Achievements
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/programme', 'about']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                About the Programme
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/live-well', 8]"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['far', 'heart-circle-check']"></fa-icon>
            </span>
            <span class="nav-link-title">Live Well</span>
          </a>
        </li>
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/activity']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'heartbeat']"></fa-icon>
            </span>
            <span class="nav-link-title">Move Well</span>
          </a>
          <ul class="nav flex-column fade-in animate-250">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/activity', 'steps']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Prep Steps
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/activity', 'fit']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap  duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Prep Fit
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/activity', 'move']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Prep Strong
              </a>
            </li>
            <li class="nav-item" 
            *ngIf="userData && userData.block_breathewell != 1">
              <a
                class="nav-link"
                [routerLink]="['/activity', 'breathe']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Breathe Well
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item"  *ngIf="userData && userData.smoke=='1'">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules', 'i-quit']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['far', 'ban-smoking']"></fa-icon>
            </span>
            <span class="nav-link-title"> I-Quit</span>
          </a>
        </li>

        <li class="nav-item" *ngIf="userData && userData.drink=='1'">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules', 'drinking-guide']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'martini-glass']"></fa-icon>
            </span>
            <span class="nav-link-title"> Drink Guide</span>
          </a>
        </li>

        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules', 'feel-well']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['far', 'face-smile-relaxed']"></fa-icon>
            </span>
            <span class="nav-link-title"> Feel Well</span>
          </a>
        </li>

        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules', 'sleep-well']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['far', 'face-sleeping']"></fa-icon>
            </span>
            <span class="nav-link-title"> Sleep Well</span>
          </a>
        </li>
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules', 'eat-well']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'cutlery']"></fa-icon>
            </span>
            <span class="nav-link-title"> Eat Well</span>
          </a>
        </li>


        <!--li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/modules']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'user-chart']"></fa-icon>
            </span>
            <span class="nav-link-title">Modules</span>
          </a>
          <ul class="nav flex-column fade-in animate-250">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/modules', 'i-quit']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                I-Quit
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/modules', 'drinking-guide']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Drink Guide
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/modules', 'feel-well']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Feel Well
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/modules', 'sleep-well']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Sleep Well
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/modules', 'eat-well']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Eat Well
              </a>
            </li>
          </ul>
        </li-->
        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/social']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['fas', 'comments-alt']"></fa-icon>
            </span>
            <span class="nav-link-title">Social</span>
          </a>
          <ul class="nav flex-column fade-in animate-250">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/social', 'forum']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Share your story
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/social', 'healthcare-professional']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Ask a healthcare professional
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/social', 'support']"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Technical Support
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a
          (click)="toggleUserMenu=false"
            class="nav-link"
            [routerLink]="['/more']"
            routerLinkActive="active"
          >
            <span class="nav-icon icon-wrap">
              <fa-icon [icon]="['far', 'ellipsis-h']"></fa-icon
            ></span>
            <span class="nav-link-title">More</span>
          </a>
          <ul class="nav flex-column fade-in animate-250">
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/more', 'app']"
                routerLinkActive="active"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Install Web App
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/more', 'about']"
                routerLinkActive="active"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                About
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/more', 'terms']"
                routerLinkActive="active"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Terms and Conditions
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                [routerLink]="['/more', 'privacy']"
                routerLinkActive="active"
              >
                <span class="icon-wrap duo-primary-dark">
                  <fa-icon [icon]="['fad', 'arrow-circle-right']"></fa-icon>
                </span>
                Privacy Policy
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>
